import type { components } from "@/api-schema";
import type { RowWithIdentifier } from "@/components/data-table/_helpers/row-identifier";
import { useCallback, type ReactElement } from "react";
import { useLocation } from "wouter";
import { GroupRuleSection } from "../../_components/group-rule-section";

type Rule = components["schemas"]["Rule"] & RowWithIdentifier;

export function RulesTab({ groupUuid, canManage }: { groupUuid: string; canManage: boolean }): ReactElement {
  const [, navigate] = useLocation();

  const handleRuleEdit = useCallback(
    (rule: Rule) => navigate(`~/ram/group/${groupUuid}/rule/${rule.uuid}/update`),
    [groupUuid, navigate],
  );

  return <GroupRuleSection groupUuid={groupUuid} canManage={canManage} onRuleEdit={handleRuleEdit} />;
}
